import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\BcSolutions\RegisterCompanyToBcSolutionsController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/RegisterCompanyToBcSolutionsController.php
* @route '/api/company/{company}/peppol/bcsolutions/register'
*/
const RegisterCompanyToBcSolutionsController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RegisterCompanyToBcSolutionsController.url(args, options),
    method: 'post',
})

RegisterCompanyToBcSolutionsController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/peppol/bcsolutions/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Partner\BcSolutions\RegisterCompanyToBcSolutionsController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/RegisterCompanyToBcSolutionsController.php
* @route '/api/company/{company}/peppol/bcsolutions/register'
*/
RegisterCompanyToBcSolutionsController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return RegisterCompanyToBcSolutionsController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\BcSolutions\RegisterCompanyToBcSolutionsController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/RegisterCompanyToBcSolutionsController.php
* @route '/api/company/{company}/peppol/bcsolutions/register'
*/
RegisterCompanyToBcSolutionsController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RegisterCompanyToBcSolutionsController.url(args, options),
    method: 'post',
})

export default RegisterCompanyToBcSolutionsController